<template>
  <div class="servico_bolsas_detalhe" v-if="noticia != null">
    <div class="row align-center">
      <div class="small-12 medium-12 large-12 columns bolsa_detalhe">
        <div class="row prccontent">
          <div class="small-12 medium-12 large-12 columns"> 
            <h1>{{noticia.titulo}}</h1>
            <h5>{{noticia.subtitulo}}</h5>
            <p class="ncontent" v-html="noticia.corpo"></p>
          </div>
        </div>
      </div>
    </div>
    <router-link class="button botao_detalhe" to="/noticias-e-eventos">
      {{ $t("noticias.vertodos") }}
    </router-link>
  </div>
</template>
  
<script>
  import { onBeforeRouteLeave, useRoute } from 'vue-router';
  import { useDetailStore } from '@/stores/detail.js'
  import { useBreadcrumbStore } from '@/stores/breadcrumb';
  import { computed } from "vue";
  import axios from '@/axios';
  import { i18n } from "@/main.js";
  
  export default {
    setup() {
  
      const store = useDetailStore();
      const noticia = computed(() => store.currentDetailItem);
      const bstore = useBreadcrumbStore();
  
      const fetchDocuments = (id) => {
        return axios.get(`/simplenews/${id}?idioma=${i18n.global.locale}` )
          .then(resp => {
            const item = resp.data.data[0];
            store.setCurrentDetailItem(item);
            bstore.addSection("Notícias e Eventos","/noticias-e-eventos");

            const truncatedTitle = item.titulo.length > 21 
              ? item.titulo.substring(0, 20) + "(...)" 
              : item.titulo;

            bstore.addSection(truncatedTitle, "");
          })
          .catch(error => {
            console.log(error);
          })
      }

      if(noticia.value != undefined){  
        const truncatedTitle = noticia.value.titulo.length > 21 
              ? noticia.value.titulo.substring(0, 20) + "(...)" 
              : noticia.value.titulo;
        bstore.addSection(truncatedTitle, "");
      }else{
        const route = useRoute();
        fetchDocuments(route.params.id)
      }
     
      onBeforeRouteLeave((to, from, next) => {
        bstore.removeLastSection();
        next()
      })
  
  
      return {
        noticia
      }
    }
  }
</script>
  
<style lang="scss" scoped>
.prccontent > .columns:first-of-type {
  padding-left: 50px;
  padding-right: 40px;
  padding-bottom: 60px;
}

@media screen and (max-width:1024px) {

  .prccontent > .columns:first-of-type {
    padding-left: 0;
  }

  .prccontent > .columns{
    padding-right: 25px;
  }

  .prccontent, 
  .servico_bolsas_detalhe, 
  .bolsa_detalhe{
    padding-left: 0;
    padding-right: 0;
  }

  .prccontent{
    margin-left: 42px;
    margin-right: 0;
  }

  .prccontent > .columns {
    padding: 0;
    padding-right: 25px;
  }
}

@media screen and (max-width:767px) {
  .prccontent{
    margin-left: 15px;
  }

  .prccontent > .columns:first-of-type {
    padding-right: 15px;
  }
}


/*#region BoxLayout*/
.servico_bolsas_detalhe>.row {
  border: 1px solid #6eb7ec;
  margin-bottom: 40px;
  margin-top: 60px;
  margin-left: 0px;
  margin-right: 0px;
}

@media (max-width: 767px) {
  .bolsa_detalhe {
    padding-right: 0px;
    padding-left: 0px;
  }
}
/*#endregion*/

.bolsa_detalhe h1 {
  font-family: "Montserrat Bold" !important;
  font-size: 24px !important;
  padding-bottom: 10px !important;
  margin-top: 50px !important;
  color: #535d61 !important;
}

/*#region Button*/
.botao_detalhe {
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  background-color: #6eb7ec;
}

.button.botao_detalhe {
  padding: 20px;
  margin-bottom: 100px;
  margin-left: 35px;
}

@media (max-width: 767px) {

  .servico_bolsas_detalhe{
    margin-left: -15px;
  }

  .button.botao_detalhe {
    margin-left: 0px;
    width: 100%;
    padding: 20px;
    margin-bottom: 100px;
  }

  .servico_bolsas_detalhe>.row {
    margin-top: 18px;
  }

}

.ncontent:deep(p), .ncontent:deep(ul li),
.ncontent:deep(div), .ncontent:deep(ol){
    font-size: 16px !important;
    margin-bottom: 30px !important;
    margin-top: 5px !important;
    font-family: 'PT Sans' !important;
    color: #656565 !important;
}

.ncontent:deep(ul){
  margin-left: 1.25rem
}

.ncontent:deep(a) {
  font-family: "PT Sans Bold" !important;
  text-decoration: underline !important;
  color: #1779ba !important;
}

/*#endregion*/
</style>